var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('Header',{on:{"sendScrollTop":_vm.getScrollTop}}),_c('router-view',{attrs:{"scrollTopNum":_vm.scrollTopNum}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }